import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 12px;
    overflow: auto;
    height: 100%;
    box-sizing: border-box;
    font-family: inherit;
    font-size: 20px;
    color: #abb2bf;
  }

  .toolbar {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
    align-items: center;
  }

  .mock-count {
    margin-left: auto;
    font-size: 15px;
    color: #5c6370;
  }

  .btn {
    padding: 5px 12px;
    background: #2c313a;
    color: #abb2bf;
    border: 1px solid #3e4451;
    cursor: pointer;
    font-size: 18px;
    border-radius: 3px;
    font-family: inherit;
  }

  .btn:hover {
    border-color: #abb2bf;
  }

  .btn-danger {
    color: #e06c75;
    border-color: #e06c75;
  }

  .btn-disabled {
    color: #5c6370;
    border-color: #3e4451;
    cursor: default;
  }

  .section-heading {
    margin: 16px 0 6px;
    font-size: 15px;
    color: #528bff;
    text-transform: uppercase;
    letter-spacing: 1.4px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .section-heading:hover {
    color: #7aadff;
  }

  .form {
    background: #2c313a;
    border: 1px solid #3e4451;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .form-row {
    display: grid;
    grid-template-columns: 90px 1fr;
    align-items: start;
    gap: 8px;
    font-size: 17px;
  }

  .form-label {
    color: #5c6370;
    padding-top: 6px;
    font-size: 16px;
    white-space: nowrap;
  }

  .form-input,
  .form-select,
  .form-textarea {
    background: #21252b;
    border: 1px solid #3e4451;
    color: #abb2bf;
    font-size: 17px;
    font-family: inherit;
    border-radius: 3px;
    padding: 5px 8px;
    width: 100%;
    box-sizing: border-box;
  }

  .form-input:focus,
  .form-select:focus,
  .form-textarea:focus {
    outline: none;
    border-color: #528bff;
  }

  .form-textarea {
    min-height: 72px;
    resize: vertical;
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 15px;
  }

  .form-checkbox-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 17px;
    color: #abb2bf;
    cursor: pointer;
  }

  .form-checkbox-row input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #528bff;
  }

  .form-footer {
    display: flex;
    justify-content: flex-end;
    padding-top: 4px;
  }

  .btn-add {
    color: #98c379;
    border-color: #98c379;
    padding: 5px 18px;
  }

  .btn-save {
    color: #61afef;
    border-color: #61afef;
    padding: 5px 18px;
  }

  .btn-cancel {
    color: #5c6370;
    border-color: #3e4451;
    padding: 5px 14px;
    margin-right: 8px;
  }

  .mock-row {
    display: grid;
    grid-template-columns: auto 1fr auto auto auto auto;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    border-bottom: 1px solid #2c313a;
    font-size: 18px;
    font-family: inherit;
  }

  .mock-row--disabled {
    opacity: 0.45;
  }

  .mock-row--editing {
    background: #2c313a;
    border-radius: 3px;
  }

  .method-badge {
    font-size: 13px;
    font-weight: 700;
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    padding: 2px 6px;
    border-radius: 3px;
    background: #1a1d23;
    white-space: nowrap;
  }

  .method-GET {
    color: #98c379;
    border: 1px solid #98c379;
  }
  .method-POST {
    color: #61afef;
    border: 1px solid #61afef;
  }
  .method-PUT {
    color: #e5c07b;
    border: 1px solid #e5c07b;
  }
  .method-DELETE {
    color: #e06c75;
    border: 1px solid #e06c75;
  }
  .method-PATCH {
    color: #c678dd;
    border: 1px solid #c678dd;
  }

  .mock-url {
    font-family: 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace;
    font-size: 16px;
    color: #abb2bf;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mock-label {
    font-size: 14px;
    color: #5c6370;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mock-status {
    font-size: 15px;
    color: #5c6370;
    white-space: nowrap;
  }

  .toggle-btn {
    padding: 3px 10px;
    background: #2c313a;
    border-radius: 3px;
    cursor: pointer;
    font-size: 15px;
    font-family: inherit;
    font-weight: 600;
    white-space: nowrap;
  }

  .toggle-btn--on {
    color: #528bff;
    border: 1px solid #528bff;
  }

  .toggle-btn--off {
    color: #5c6370;
    border: 1px solid #5c6370;
  }

  .edit-btn {
    padding: 3px 8px;
    background: transparent;
    border: 1px solid #3e4451;
    color: #e5c07b;
    border-radius: 3px;
    cursor: pointer;
    font-size: 15px;
    font-family: inherit;
  }

  .edit-btn:hover {
    border-color: #e5c07b;
  }

  .delete-btn {
    padding: 3px 8px;
    background: transparent;
    border: 1px solid #3e4451;
    color: #e06c75;
    border-radius: 3px;
    cursor: pointer;
    font-size: 15px;
    font-family: inherit;
  }

  .delete-btn:hover {
    border-color: #e06c75;
  }

  .empty {
    padding: 16px;
    color: #5c6370;
    font-size: 18px;
    font-family: inherit;
  }
`;
